import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import DesignCard from "../DesignCard";
import CustomButton from "../CustomButton";

import get from "lodash/get";
import moment from "moment";
import { slice } from "lodash";
import config from "../../utils/config";
import { Icon } from "react-icons-kit";
import { filePdfO } from "react-icons-kit/fa/filePdfO";
import { useDispatch } from "react-redux";

const _ = { get };

const initialState = {
  status: "",
  toggleRejectModal: false,
  vin: "",
  toggleEditVin: false,
  editId: "",
  previewImage: false,
  imageDetail: null,
};
export default function VinDetailPopup(props) {
  let { elements, rowData } = props;

  const [state, setState] = useState(initialState);
  const dispatch = useDispatch();

  const handleGoBack = () => {
    props.handleToggleModel();
  };

  const handleToggleRejectModal = (e, status) => {
    e.preventDefault();
    state.toggleRejectModal = !state.toggleRejectModal;
    state.status = status;
    setState({ ...state });
  };

  const handlePreviewImages = (e, image) => {
    let newState = { ...state };
    newState.previewImage = !state.previewImage;
    newState.imageDetail = image;
    setState(newState);
  };

  const handleStatusSubmit = (e, status) => {
    e.preventDefault();
    let data = {
      status: state.status,
      vin: rowData.vin,
      page: props.page,
      count: props.count,
      currentStatus: props.currentStatus,
      email: props.email,
      phone: props.phone,
    };
    state.toggleRejectModal = !state.toggleRejectModal;
    setState({ ...state });
    props.handleToggleModel();
    props.handleStatusSubmit(data);
  };

  useEffect(() => {
    state.toggleRejectModal = false;
    setState({ ...state });
  }, []);

  useEffect(() => {
    if (rowData) {
      props.fetchTransferModerationDetailListing(rowData);
    }
  }, [rowData]);

  return (
    <React.Fragment>
      <div className="hideSearch">
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={_.get(
                  elements,
                  "vinModerationDetailElement.vinDetailHeadingElement",
                  "VIN Details"
                )}
                iconClass={"hideexcel"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
              />
            </Col>
          </Row>
          <Card className="mb-3">
            <CardBody>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        elements,
                        "vinModerationDetailElement.subHeadingUserElement",
                        "User Details"
                      )}
                    </span>
                  </h2>
                </Col>
              </Row>

              <Row>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "vinModerationDetailElement.currentOwnerEmailLabel",
                      "Current Owner Email Id"
                    )}
                    titleName={
                      props.transferModerationDetailListing.previousOwner
                        ? props.transferModerationDetailListing.previousOwner &&
                          props.transferModerationDetailListing.previousOwner
                            .contactDetails &&
                          props.transferModerationDetailListing.previousOwner
                            .contactDetails.email
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "vinModerationDetailElement.newOwnerEmailLabel",
                      "New Owner Email Id"
                    )}
                    titleName={
                      props.transferModerationDetailListing.currentOwner
                        ? props.transferModerationDetailListing.currentOwner &&
                          props.transferModerationDetailListing.currentOwner
                            .contactDetails &&
                          props.transferModerationDetailListing.currentOwner
                            .contactDetails.email
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "vinModerationDetailElement.modelNameLabel",
                      "Model Name"
                    )}
                    titleName={rowData.vehicleModelName}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "vinModerationDetailElement.vinLabel",
                      "VIN"
                    )}
                    titleName={rowData.vin}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "vinModerationDetailElement.createdAtLabel",
                      "Created At (GMT)"
                    )}
                    titleName={moment(rowData.createdAt)
                      .utc()
                      .format("DD-MM-YY, HH:mm:ss")}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "vinModerationDetailElement.updatedAtLabel",
                      "Updated At (GMT)"
                    )}
                    titleName={moment(rowData.updatedAt)
                      .utc()
                      .format("DD-MM-YY, HH:mm:ss")}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "vinModerationDetailElement.modelCodeLabel",
                      "Model Code"
                    )}
                    titleName={rowData.vehicleModelCode}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "vinModerationDetailElement.modelColorLabel",
                      "Model Color"
                    )}
                    titleName={rowData.vehicleModelColor}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "vinModerationDetailElement.registrationNumberLabel",
                      "Registration Number"
                    )}
                    titleName={
                      rowData.registrationNo ? rowData.registrationNo : "N/A"
                    }
                  />
                </Col>
              </Row>
              <Row>
                {rowData.rceDocuments.map((image) => (
                  <>
                    {["png", "jpg", "jpeg"].includes(
                      image.slice(image.lastIndexOf(".") + 1)
                    ) && (
                      <>
                        <Col
                          xl={3}
                          lg={4}
                          md={6}
                          sm={12}
                          w-100
                          className="img_Tag mb-3"
                        >
                          {" "}
                          <img
                            src={`${config.imageBaseUrl}/${image}`}
                            onClick={(e) => handlePreviewImages(e, image)}
                          />
                        </Col>
                      </>
                    )}
                    {["pdf"].includes(
                      image.slice(image.lastIndexOf(".") + 1)
                    ) && (
                      <Col xl={3} lg={4} md={6} sm={12} className="mb-3">
                        <a
                          className="pdfLink_Tag"
                          href={`${config.imageBaseUrl}/${image}`}
                          download
                          target="_blank"
                          rel="noopener"
                        >
                          <div className="pdf_Border align-items-center text-center text-break position-relative">
                            <div className="position-absolute pdf_Center_Text">
                              <div>
                                <Icon
                                  size={20}
                                  icon={filePdfO}
                                  // className={Global.btnIcon}
                                />
                              </div>
                              <div className="pdf_Font" title="Click to PDF">
                                {image.slice(image.lastIndexOf("/") + 1)}
                              </div>
                            </div>
                          </div>
                        </a>
                      </Col>
                    )}
                  </>
                ))}
              </Row>
              <div className="d-flex justify-content-center justify-content-lg-end position-relative mt-3">
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "vinModerationDetailElement.backButtonElement",
                    "Back"
                  )}
                  customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                  customClick={(e) => handleGoBack(e)}
                />
                {rowData.vehicleStatus === "PENDING" && (
                  <React.Fragment>
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "vinModerationDetailElement.rejectButtonElement",
                        "Reject"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-2 btnthemeColor"
                      }
                      customClick={(e) =>
                        handleToggleRejectModal(e, "REJECTED")
                      }
                    />
                    <CustomButton
                      customType={"submit"}
                      name={_.get(
                        elements,
                        "vinModerationDetailElement.approveButtonElement",
                        "Approve"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-2 btnthemeColor"
                      }
                      customClick={(e) =>
                        handleToggleRejectModal(e, "APPROVED")
                      }
                    />
                  </React.Fragment>
                )}
              </div>
            </CardBody>
          </Card>
        </Form>
        <Modal isOpen={state.toggleRejectModal}>
          <ModalHeader toggle={handleToggleRejectModal}>
            {_.get(
              elements,
              "vinModerationDetailElement.confirmationLabel",
              "Confirmation"
            )}
          </ModalHeader>
          <ModalBody>
            {_.get(
              elements,
              "vinModerationDetailElement.validationElement",
              "Are you sure you want to"
            )}{" "}
            {state.status === "APPROVED" && "Approve ?"}
            {state.status === "REJECTED" && "Reject ?"}
          </ModalBody>
          <ModalFooter>
            <CustomButton
              customType={"submit"}
              name={_.get(
                elements,
                "vinModerationDetailElement.confirmButtonElement",
                "Confirm"
              )}
              customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
              customClick={(e) => handleStatusSubmit(e)}
            />
          </ModalFooter>
        </Modal>
        <Modal size="m" centered isOpen={state.previewImage}>
          <ModalHeader toggle={handlePreviewImages} className="dotted_Heading">
            {state.imageDetail &&
              state.imageDetail.slice(state.imageDetail.lastIndexOf("/") + 1)}
          </ModalHeader>
          <ModalBody>
            <div>
              {["png", "jpg", "jpeg"].includes(
                state.imageDetail &&
                  state.imageDetail.slice(
                    state.imageDetail.lastIndexOf(".") + 1
                  )
              ) && (
                <>
                  <img
                    src={`${config.imageBaseUrl}/${state.imageDetail}`}
                    className="w-100"
                  />
                  {console.log("name", state.imageDetail)}
                </>
              )}
            </div>
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>
  );
}
